<ng-container *ngIf="_camps || _projetsAnnee">
  <div class="row">
    <div class="col-md-12">
      <mat-card class="ddc-card-with-title">
        <mat-card-title>
          <span ddcLabel labelKey="{{_titleLabelKey}}"></span>
        </mat-card-title>
        <mat-card-content>
          <ng-container
            *ngIf="(_camps && _camps.length > 0) || (_projetsAnnee && _projetsAnnee.length > 0); else noResultsBlock">
            <div class="ddc-appli-description">
              <span>Le nombre total de résultats trouvés est
                <ng-container *ngIf="_projetsAnnee; else campsBlock">
                  <b>{{this._nbreTotalItems}}</b>
                </ng-container>
                <ng-template #campsBlock>
                  <b>{{this._nbreTotalItems}}</b>
                </ng-template>
              </span>
            </div>
            <ng-container *ngIf="_camps; else projetsAnneeBlock">
              <ddc-camps-information-table
                [camps]="_camps"
                [campDisplayedColumns]="_displayedColumns"
                (updateSortParams)="updateSortParams($event)"
                [listePays]="_listePays"
              >
              </ddc-camps-information-table>
            </ng-container>
            <ng-template #projetsAnneeBlock>
              <ddc-projets-annee-information-table
                [projetsAnnee]="_projetsAnnee"
                [projetsAnneeDisplayedColumns]="_displayedColumns"
                (updateSortParams)="updateSortParams($event)"
              >
              </ddc-projets-annee-information-table>
            </ng-template>

            <div class="ddc-pagination">
              <ddc-pagination [nbreItems]="_nbreTotalItems" [itemsPerPage]="_itemsPerPage" (pageChanged)="onChangePage($event)"></ddc-pagination>
            </div>

          </ng-container>
          <ng-template #noResultsBlock>
            <div class="ddc-warning-message">
              <span class="material-icons">info</span>
              <span>Aucun résultat trouvé</span>
            </div>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</ng-container>
